import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

/**
 * Search model for PosUser
 *
 */
@Injectable()
export class PosuserSearchModel extends SearchModel<any> {


    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "userId";
    }
}
